import { notification } from 'antd';
import { createBuyerPointFx, fetchBuyerPointsFx } from '../store/points.store';

export const createBuyerPoint = async ({
  nameString,
  pointName,
  hasMixer,
  buyerId,
  setModalVisible,
  setAddressString,
}: {
  nameString: string;
  pointName: any;
  buyerId: number;
  hasMixer: number;
  setModalVisible: (val: boolean) => void;
  setAddressString: (val: string) => void;
}) => {
  try {
    const res = await createBuyerPointFx({
        ...pointName,
        enabled: 1,
        name: nameString,
        buyer_id: buyerId,
        city: pointName.area,
        has_mixer: hasMixer,
      });
    await fetchBuyerPointsFx();
    notification.success({ message: 'Пункт приема зерна успешно добавлен' });
    return res;
  } catch (err: any) {
    return notification.error({
      message: err.message
        ? `Непредвиденная ошибка. Попробуйте позже ${err.message}`
        : 'Непредвиденная ошибка. Попробуйте позже',
    });
  }
};
